import { render, staticRenderFns } from "./CovidScreeningStudents.vue?vue&type=template&id=4f20f9bc&"
import script from "./CovidScreeningStudents.vue?vue&type=script&lang=js&"
export * from "./CovidScreeningStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports